// Cart Attribute Toggle – v3  |  assets/cart-toggle.js
// Reads config from window.NGW_CartBlog (injected by the Liquid section).
// Toggle ON  → POST /cart/update.js  { attributes: { key: value } }
// Toggle OFF → POST /cart/update.js  { attributes: { key: '' } }  (Shopify removes empty attributes)
//
// v3 changes:
//   - Hydrates the toggle from the actual cart on load (GET /cart.js) so state persists across refresh.
//   - Treats the POST response cart as the source of truth (optimistic UI with rollback on failure).
//   - Keeps every rendered toggle in sync with one cached state value.
(function () {
  'use strict';

  var C = Object.assign({
    selectors   : [
      // ── cart page (static /cart)
      '.buy-buttons--compact',
      '.cart-order__recap button[name=checkout]',
    ],
    key         : 'cart_att_option',
    value       : 'yes',
    title       : 'Special Option',
    description : 'Enable this option to unlock special functionality for your order.',
    color       : '#10b981',
    iconUrl     : '',
  }, window.NGW_CartBlog || {});

  // Accept selectors as a comma-joined string OR an array; trim and drop empties/nulls.
  if (typeof C.selectors === 'string') C.selectors = C.selectors.split(',');
  C.selectors = (C.selectors || [])
    .map(function (s) { return s == null ? '' : String(s).trim(); })
    .filter(Boolean);

  var P = 'ngw-cbt', W = 'data-' + P;  // use data-attr marker, not id (id must be unique)

  // ── State ────────────────────────────────────────────────────────────────
  // null = unknown (not yet fetched). Once known, every checkbox is synced to it.
  var state = null;

  // ── Styles ──────────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById(P)) return;
    var s = document.createElement('style');
    s.id = P;
    s.textContent =
      '.' + P + '{display:flex;align-items:center;gap:12px;padding:14px 16px;margin:12px 0;border:1px solid #e5e7eb;border-radius:10px;background:#fff;box-sizing:border-box;font-family:inherit}' +
      '.' + P + '__body{flex:1;min-width:0}' +
      '.' + P + '__title{margin:0 0 3px;font-size:14px;font-weight:600;color:#111827}' +
      '.' + P + '__desc{margin:0;font-size:12px;color:#6b7280}' +
      '.' + P + '__sw{position:relative;flex-shrink:0;display:inline-block;width:44px;height:26px;cursor:pointer}' +
      '.' + P + '__cb{position:absolute;opacity:0;width:0;height:0}' +
      '.' + P + '__cb:disabled~.' + P + '__sw,.' + P + '__sw.is-busy{opacity:.6;cursor:progress}' +
      '.' + P + '__tr{position:absolute;inset:0;background:#d1d5db;border-radius:26px;transition:background .2s}' +
      '.' + P + '__th{position:absolute;width:20px;height:20px;top:3px;left:3px;background:#fff;border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.2);transition:transform .2s}' +
      '.' + P + '__cb:checked~.' + P + '__tr{background:' + C.color + '}' +
      '.' + P + '__cb:checked~.' + P + '__th{transform:translateX(18px)}' +
      '.' + P + '__cb:focus-visible~.' + P + '__tr{outline:2px solid ' + C.color + ';outline-offset:2px}' +
      '@media(max-width:380px){.' + P + '__sw{width:38px;height:22px}.' + P + '__th{width:16px;height:16px}.' + P + '__cb:checked~.' + P + '__th{transform:translateX(16px)}}';
    document.head.appendChild(s);
  }

  // ── Read current state from a cart object ─────────────────────────────────
  function readState(cart) {
    var attrs = (cart && cart.attributes) || {};
    return attrs[C.key] === C.value;
  }

  // ── Push the cached state onto every rendered checkbox ───────────────────
  function applyState() {
    if (state === null) return;
    document.querySelectorAll('.' + P + '__cb').forEach(function (cb) {
      cb.checked = state;
    });
  }

  // ── Fetch current cart and hydrate (called once on init) ──────────────────
  function fetchState() {
    fetch('/cart.js', {
      method: 'GET', credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { state = readState(cart); applyState(); })
      .catch(function () { /* leave state null; UI stays at default */ });
  }

  // ── Toggle: optimistic UI, server response is the source of truth ─────────
  function updateAttr(on, cb) {
    var prev = state;
    state = on;            // optimistic
    applyState();
    if (cb) cb.disabled = true;

    var b = {};
    b[C.key] = on ? C.value : ''; // empty string → Shopify removes the attribute

    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: b }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed: ' + r.status);
        return r.json();
      })
      .then(function (cart) { state = readState(cart); applyState(); })   // confirm with server
      .catch(function () { state = prev; applyState(); })                  // roll back on failure
      .then(function () { if (cb) cb.disabled = false; });
  }

  // ── Widget ───────────────────────────────────────────────────────────────
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function render() {
    var icon = C.iconUrl
      ? '<img style="flex-shrink:0;width:36px;height:36px;border-radius:6px;object-fit:cover" src="' + esc(C.iconUrl) + '" alt="">'
      : '';

    var targets = document.querySelectorAll(C.selectors.join(','));
    targets.forEach(function (t) {
      // skip if widget already injected immediately before this target
      var prev = t.previousElementSibling;
      if (prev && prev.hasAttribute(W)) return;

      t.insertAdjacentHTML('beforebegin',
        '<div ' + W + ' class="' + P + '">' + icon +
        '<div class="' + P + '__body"><p class="' + P + '__title">' + esc(C.title) + '</p>' +
        '<p class="' + P + '__desc">' + esc(C.description) + '</p></div>' +
        '<label class="' + P + '__sw" aria-label="' + esc(C.title) + '">' +
        '<input class="' + P + '__cb" type="checkbox">' +
        '<span class="' + P + '__tr"></span><span class="' + P + '__th"></span></label></div>'
      );

      var cb = t.previousElementSibling.querySelector('.' + P + '__cb');
      cb.addEventListener('change', function () { updateAttr(this.checked, this); });
    });

    // Sync any freshly-rendered checkboxes to the known state.
    applyState();
  }

  // ── Re-render on AJAX cart updates ───────────────────────────────────────
  var busy = false;
  new MutationObserver(function () {
    if (busy) return;
    busy = true;
    requestAnimationFrame(function () { render(); busy = false; });
  }).observe(document.body, { childList: true, subtree: true });

  injectStyles();
  fetchState();   // hydrate from the real cart
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', render)
    : render();

}());